/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  getListableApiParams
 */

import { LISTABLES_API_LIMIT } from '@zcode/nr/es/shared/constants/list'
import { getBoxJS } from '@zcode/nr/es/shared/utils/location'
import type { Filters, Location as CurrentSearchLocation } from '@zcode/state-type'

import { getAPIFriendlyFilters } from './getAPIFriendlyFilters'

// NOTE: not changing this with https://zumper.atlassian.net/browse/ZUM-59330 as this function's current usage
// does not include current map list results
export const NEARBY_LIMIT = 15

export const getListablesApiParams = ({
  filters,
  jsFilters = {},
  location = {},
  matching = true,
}: {
  jsFilters?: Partial<
    Filters & {
      excludeGroupIds?: readonly number[]
      limit?: number
      matching?: boolean
      nearby?: number
      offset?: number
    }
  >
  filters?: Filters
  location: Partial<CurrentSearchLocation>
  matching?: boolean
}) => {
  const query = {
    ...filters,
    ...jsFilters,
  }
  if (matching) {
    query.matching = true
  }
  if (!jsFilters.byIds) {
    Object.assign(query, getBoxJS(location))
  }
  if (location.url) {
    query.url = location.url
  }
  if (!query.byIds) {
    query.limit = LISTABLES_API_LIMIT
  }

  // Only request nearby on the first page. Never for other pages.
  if (!query.excludeGroupIds && !query.offset) {
    query.nearby = NEARBY_LIMIT
  }

  return getAPIFriendlyFilters({
    filters: query,
  })
}
